import { gql } from "@apollo/client";

export const sale_report = gql`
  query SaleReport(
    $clinic_code: String!
    $from_date: DateTime!
    $to_date: DateTime!
    $seller_id: String
    $customer_id: String
    $take: Int!
    $skip: Int!
  ) {
    saleReport(
      clinic_code: $clinic_code
      from_date: $from_date
      to_date: $to_date
      seller_id: $seller_id
      customer_id: $customer_id
      take: $take
      skip: $skip
    ) {
      data {
        visit_date
        clinic_code
        clinic_name
        customer_id
        customer_name
        customer_phone
        seller_id
        seller_name
        services
        payment_amount
        payment_method
        payment_note
        practitioner
        helper
        is_new_customer_in_clinic
      }
      total
    }
  }
`;

export const getSaleReportVar = (data: {
  clinic_code: string;
  from_date: Date;
  to_date: Date;
  seller_id?: string;
  customer_id?: string;
  take: number;
  skip: number;
}) => {
  const variables: any = {
    clinic_code: data.clinic_code,
    from_date: data.from_date,
    to_date: data.to_date,
    take: data.take,
    skip: data.skip,
  };

  if (data.seller_id) {
    variables.seller_id = data.seller_id;
  }

  if (data.customer_id) {
    variables.customer_id = data.customer_id;
  }

  return variables;
};

export const sale_group_report = gql`
  query SaleGroupReport(
    $clinic_code: String!
    $from_date: DateTime!
    $to_date: DateTime!
    $seller_id: String
    $report_type: ReportType!
    $take: Int!
    $skip: Int!
  ) {
    saleGroupReport(
      clinic_code: $clinic_code
      from_date: $from_date
      to_date: $to_date
      seller_id: $seller_id
      report_type: $report_type
      take: $take
      skip: $skip
    ) {
      data {
        clinic_code
        clinic_name
        customer_id
        customer_name
        customer_phone
        seller_id
        seller_name
        payment_amount
      }
      total
    }
  }
`;

export const getSaleGroupReportVar = (data: {
  clinic_code: string;
  from_date: Date;
  to_date: Date;
  seller_id?: string;
  report_type: "SALE_BY_SALESPERSON" | "CUSTOMER_BY_SALESPERSON";
  take: number;
  skip: number;
}) => {
  const variables: any = {
    clinic_code: data.clinic_code,
    from_date: data.from_date,
    to_date: data.to_date,
    report_type: data.report_type,
    take: data.take,
    skip: data.skip,
  };

  if (data.seller_id) {
    variables.seller_id = data.seller_id;
  }

  return variables;
};
